import { TextField } from "@mui/material";
import { TextFieldStyles } from "../../styles/commonStyles";
import { useEffect, useState } from "react";
import { validateEmail } from "../../utils/errorUtils";
import CustomAlert from "../alert/alert.component";
import FormActionButton from "../buttons/formActionButton.component";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordRequestStart } from "../../store/features/resetPassword/resetPasswordRequestSlice";

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [validationError, setValidationError] = useState("");

  const { success, error, isLoading } = useSelector(
    (state) => state.resetPasswordRequest
  );

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    if (validationError) {
      setValidationError("");
    }
  };
  const validateForm = () => {
    if (!email.trim()) {
      setValidationError("L'indirizzo email è obbligatorio");
      return false;
    }
    if (!validateEmail(email)) {
      setValidationError("Inserisci un indirizzo email valido");
      return false;
    }
    return true;
  };
  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    dispatch(resetPasswordRequestStart({ email: email.trim() }));
  };

  const displayError = validationError;
  const hasError = !!displayError;

  useEffect(() => {
    if (success) {
      setEmail("");
      setValidationError("");
    }
  }, [success]);

  return (
    <>
      <TextField
        variant="filled"
        fullWidth
        sx={TextFieldStyles}
        label="Indirizzo E-mail"
        placeholder="Indirizzo E-mail"
        aria-label="Indirizzo E-mail"
        value={email}
        onChange={handleEmailChange}
        error={hasError}
        helperText={displayError}
        type="email"
        autoComplete="email"
      />
      {success && (
        <CustomAlert
          severity="success"
          message="Email inviata! Controlla la tua casella di posta per reimpostare la password."
        />
      )}
      {error && <CustomAlert severity="error" message={error} />}
      <FormActionButton
        label={isLoading ? "Invio in corso..." : "Invia email"}
        onClick={handleSubmit}
        variant="contained"
        disabled={isLoading}
        style={{
          textTransform: "none",
          height: "50px",
          borderRadius: 0,
          width: "100%",
        }}
      />
    </>
  );
};

export default ForgotPasswordForm;
